// Surface C marginalia format — `LESSON N · LEARN COMPLETE · M kanji · K% first-try`.
// Replaces Surface A's `EDITION I · LESSON N · FRAME M / 2,200`. The lesson zero-pad
// matches the sibling format; the kanji count is bare (no padding) since the strip
// reads as a sentence-fact, not a tabular position. Edition prefix dropped — Surface
// C is the lesson's exit, not a position within the corpus.
const padLesson = (n: number) => String(n).padStart(2, '0')

export function formatCompletedMarginalia(
    lessonNumber: number,
    kanjiCount: number,
    firstTryRate: number
): string {
    return `LESSON ${padLesson(lessonNumber)} · LEARN COMPLETE · ${kanjiCount} KANJI · ${firstTryRate}% FIRST-TRY`
}

export function formatStatsLine(
    kanjiCount: number,
    correctCount: number,
    firstTryRate: number
): string {
    const kanjiWord = kanjiCount === 1 ? 'kanji' : 'kanji'
    return `${kanjiCount} ${kanjiWord} · ${correctCount} correct · ${firstTryRate}% first-try`
}
